export enum importStatus {
  endConcatenation = 'FIN_CONCATENADO',
  preImportDataAvailable = 'PREIMPORTACION_DATOS_DISPONIBLES',
  preImportError = 'ERROR_PREIMPORTACION',
  loadingSql = 'CARGANDO_SQL',
  fixing = 'CORRIGIENDO',
}

export enum loadingStatus {
  ready = 'ready',
  error = 'error',
  loading = 'loading',
}
